module.exports = __webpack_public_path__ + "img/v1-3.f72d22a4.png";